import { Component, Inject, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import axios from 'axios';
import UserMyPageService from '@/service/userMyPage.service';
import { PrincipalService } from '@/service/principal.service';
import { SESSION_STORAGE_CONSTANTS } from '@/shared/constants/ds-constants';

const appStoreState = namespace('appStore');

@Component
export default class DeleteAccountSecondStepComponent extends Vue {
  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @Inject('principalService')
  private principalService: () => PrincipalService;

  @appStoreState.Getter
  getIsOpenFirstStepDeleteAccountModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenFirstStepDeleteAccountModal!: (payload: any) => void;

  @appStoreState.Getter
  getIsOpenSecondStepDeleteAccountModal!: boolean;

  @appStoreState.Mutation
  public setIsOpenSecondStepDeleteAccountModal!: (payload: any) => void;

  handleCloseModal(): void {
    this.setIsOpenFirstStepDeleteAccountModal(false);
    this.setIsOpenSecondStepDeleteAccountModal(false);
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  langKey = '';
  inputDeleteLogin = '';
  canDeleteAccount = false;
  isConfirmDelete = false;
  isLoadingDeleteAccount = false;

  created() {
    this.langKey = this.$store.getters.currentLanguage;
  }

  async resetService(userIdInput: string) {
    // loading
    // todo

    if (userIdInput) {
      try {
        const res = await this.userMyPageService().callApiResetService(userIdInput);

        if (res && res?.data?.statusCodeValue === 200) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      } finally {
        // console.log(1);
        // loading
        // todo
      }
    }
  }

  async deleteUser() {
    const tempUser = this.userIdentity || JSON.parse(localStorage.getItem('localStorageUser')) || {};

    if (tempUser?.id) {
      this.isLoadingDeleteAccount = true;
      const isDoneReset = await this.resetService(tempUser?.id);

      if (isDoneReset) {
        if (tempUser?.login) {
          axios
            .put(`/api/admin/users/delete`)
            .then(res => {
              this.showResponseMessage(`${this.$t('toast.delete.success')}`, `${this.$t('toast.title.success')}`, 'success', 3000);

              setTimeout(() => {
                this.handleCloseModal();
                this.logout();
              }, 3000);
            })
            .catch(error => {
              // this.showResponseMessage('Delete Account Fail!', 'Error', 'danger', 5000);
              this.isLoadingDeleteAccount = false;
              this.showResponseMessage(`${this.$t('toast.delete.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
            });
        }
      } else {
        this.isLoadingDeleteAccount = false;
        // this.showResponseMessage('Delete Account Fail!', 'Error', 'danger', 5000);
        this.showResponseMessage(`${this.$t('toast.delete.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
      }
    } else {
      // this.showResponseMessage('Delete Account Fail!', 'Error', 'danger', 5000);
      this.showResponseMessage(`${this.$t('toast.delete.fail')}`, `${this.$t('toast.title.error')}`, 'danger', 5000);
    }
  }

  async handlerClose() {
    if (this.principalService().getUserInfo()) {
      const login = this.principalService().getUserInfo().login;
      // await axios.get('api/clearTimer/' + login).then();
      await axios.get('api/removeToken').then();
    }
  }

  public logout(): void {
    this.handlerClose()
      .then(this.refreshLocalStorage)
      .catch(err => {
        this.refreshLocalStorage;
      });
  }

  refreshLocalStorage() {
    localStorage.removeItem('localStorageUser');
    localStorage.removeItem('theme');
    localStorage.removeItem('currentLanguage');
    localStorage.removeItem('ds-connectome');
    localStorage.removeItem('card-data');
    localStorage.removeItem('stock-codes');
    localStorage.removeItem('loadingDataReportCardListLocalStorage');
    localStorage.removeItem('loadingDataReportToastListLocalStorage');
    localStorage.removeItem('localStorageReportBpIdListSubscribe');
    localStorage.removeItem('localStorageUser');
    localStorage.removeItem('lang');
    sessionStorage.removeItem(SESSION_STORAGE_CONSTANTS.FEED_STATUS_TRAINING);
    this.$store.dispatch('groupsManagerStore/logout');
    this.$store.commit('logout');
    localStorage.removeItem('ds-authenticationToken');
    sessionStorage.removeItem('ds-authenticationToken');
    sessionStorage.setItem('requested-url', '/home');
    this.$root.$emit('bv::hide::modal', 'modal-my-info');
    // @ts-ignore
    window.$('#logoutModal').modal('hide');
    this.isLoadingDeleteAccount = false;
    this.$router.push('/login');

    this.$router.afterEach(() => {
      window.location.reload();
    });
  }

  checkCanDeleteUser() {
    this.inputDeleteLogin = this.inputDeleteLogin.replace(' ', '');
    const tempUser = this.userIdentity || this.$store.getters.account || {};

    if (
      this.inputDeleteLogin &&
      (tempUser?.login === this.inputDeleteLogin ||
        tempUser?.email === this.inputDeleteLogin ||
        tempUser?.phoneNumber === this.inputDeleteLogin ||
        '0'.concat(tempUser?.phoneNumber) === this.inputDeleteLogin)
    ) {
      this.canDeleteAccount = true;
    } else {
      this.canDeleteAccount = false;
    }
  }

  setIsConfirmDelete() {
    this.isConfirmDelete = !this.isConfirmDelete;
  }

  showResponseMessage(mess, title, variant, hideDelay) {
    this.$bvToast.toast(mess, {
      toaster: 'b-toaster-bottom-right',
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: hideDelay,
    });
  }
}
